// 更新数据信息
export const SET_DATA = 'SET_DATA';
